import { ISimLookupRepository } from "../domain/repositories/ISimLookupRepository";
import { SimLookupUseCase } from "../domain/useCases/SimLookupUseCase";
import { SimLookupImpl } from "../data/SimLookupImpl";
import { SimLookupViewModel } from "../presentation/viewModel/SimLookupViewModel";
import { InjectionBinding, InjectionModule } from "app/di/DependencyInjections";

export class SimLookupInjection extends InjectionModule {
  private static readonly simLookupRepositoryToken = Symbol(
    "ISimLookupRepository",
  );
  private static readonly simLookupUseCaseToken = Symbol("SimLookupUseCase");
  private static readonly simLookupViewModelToken =
    Symbol("SimLookupViewModel");

  protected static override bindings: InjectionBinding[] = [
    {
      scope: "otherRepo",
      token: this.simLookupRepositoryToken,
      useClass: SimLookupImpl,
    },
    {
      scope: "otherRepo",
      token: this.simLookupUseCaseToken,
      useClass: SimLookupUseCase,
    },
    {
      scope: "viewModel",
      token: this.simLookupViewModelToken,
      useClass: SimLookupViewModel,
    },
  ];

  static getRepo(): ISimLookupRepository {
    return this.resolve(this.simLookupRepositoryToken);
  }

  static getUseCase(): SimLookupUseCase {
    return this.resolve(this.simLookupUseCaseToken);
  }
}
